<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">

    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <!--begin::Title-->
          <div class="d-flex align-items-center">
            <h1 class="page-heading"> <svg width="32" height="29" viewBox="0 0 32 29" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_82_1744)">
                  <path
                    d="M21.795 7.11531C19.8257 7.11531 18.2199 5.51738 18.2199 3.55766C18.2199 1.59793 19.8257 0 21.795 0C23.7643 0 25.3701 1.59793 25.3701 3.55766C25.3701 5.51738 23.7643 7.11531 21.795 7.11531ZM16.3112 4.58274C16.3112 2.05017 14.2509 0.0301492 11.7363 0.0301492C9.19127 0.0301492 7.16135 2.08032 7.16135 4.58274C7.16135 7.11531 9.22157 9.13533 11.7363 9.13533C14.2812 9.13533 16.3112 7.08516 16.3112 4.58274ZM27.0667 15.9491C27.5212 15.9491 27.8848 15.5572 27.8242 15.105C27.3394 11.6076 25.8245 8.1404 21.795 8.1404C19.5227 8.1404 18.0381 9.25593 17.0989 10.8539C17.7654 11.4267 18.3714 12.09 18.8561 12.904C19.4015 13.7784 19.8863 14.8035 20.2498 15.9793H27.0667V15.9491ZM4.01041 19.2053C3.91952 19.8686 4.43457 20.5017 5.13142 20.5017H18.3411C19.0379 20.5017 19.553 19.8987 19.4621 19.2053C18.7956 14.8035 16.8565 10.4619 11.7363 10.4619C6.61599 10.4619 4.67695 14.8035 4.01041 19.2053Z"
                    fill="#265D91" />
                </g>
                <defs>
                  <filter id="filter0_d_82_1744" x="0" y="0" width="31.8308" height="28.5017"
                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_82_1744" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_82_1744" result="shape" />
                  </filter>
                </defs>
              </svg>
              Candidature
            </h1>
            <!--begin::Menu-->
          </div>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a routerLink="/accueil" class="text-muted ">Accueil</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted cursor-pointer" routerLink="/liste-appels-offres">Nos Appels d'offre </li>

            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">Candidatures </li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <!--begin::Content-->
    <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card header-->

          <form [formGroup]="searchForm">
            <div class="card-body">
              <div class="title mb-3">
                <h4>Recherche</h4>
              </div>
              <div class="row mb-5">
                <div class="col-lg-6">
                  <div class="input-group search-libre">
                    <span class="input-group-text">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                          fill="#7E7C7C" />
                      </svg>
                    </span>

                    <input type="text" data-kt-customer-table-filter="search" class="form-control ps-5" formControlName="search" (keyup.enter)="searchCandidat()"
                      placeholder="Rechercher" />
                      <div class="tooltip-container tooltip-info">
                        <div class="tooltip-trigger"><i class="fa-solid fa-circle-info"
                                style="font-size: 20px;"></i></div>
                        <div class="tooltip-content">
                            <div class="content">
                                <h4>Opérateur AND :</h4>
                                <p>Utilisez l'opérateur AND pour spécifier que les résultats doivent
                                    inclure plusieurs termes.
                                </p>
                                <p>Exemple : software AND engineer renverra des profils qui
                                    mentionnent à la fois "software" et "engineer".
                                </p>
                                <h4>Opérateur OR :</h4>
                                <p>Utilisez l'opérateur OR pour spécifier que les résultats peuvent
                                    inclure l'un des termes.
                                </p>
                                <p>Exemple : sales OR marketing renverra des profils qui mentionnent
                                    soit "sales" soit "marketing".
                                </p>
                                <h4>Opérateur NOT :</h4>
                                <p>Utilisez l'opérateur NOT pour exclure des termes spécifiques des
                                    résultats.
                                </p>
                                <p>Exemple : developer NOT manager renverra des profils qui
                                    mentionnent "developer" mais pas "manager".
                                </p>
                                <h4>Guillemets pour une expression exacte :</h4>
                                <p>Utilisez des guillemets pour rechercher une expression exacte.
                                </p>
                                <p>Exemple : "product manager" renverra des profils qui mentionnent
                                    exactement "product manager".
                                </p>
                                <h4>Parenthèses pour grouper des opérations :</h4>
                                <p>Utilisez des parenthèses pour définir l'ordre d'évaluation des
                                    opérations.
                                </p>
                                <p>Exemple : (sales OR marketing) AND manager renverra des profils
                                    qui mentionnent "sales" ou "marketing" et "manager".
                                </p>
                                <h4>Recherche standard :</h4>
                                <p>Si aucun opérateur n'est spécifié dans la recherche, le texte
                                    sera interprété comme s'il était entre guillemets.
                                </p>
                                <p>Exemple : La recherche product manager sera traitée comme
                                    "product manager", suivant la règle 4.
                                </p>
                            </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tools">
                <div class="row">
                  <div class="col-lg-3">
                    <input type="text" id="id" class="form-control form-control-solid mb-3"
                      formControlName="company_name" placeholder="Entreprise">
                  </div>
                  <div class="col-lg-3">
                    <input type="text" id="nom" formControlName="candidate_name"
                      class="form-control form-control-solid mb-3" placeholder="Nom candidat">
                  </div>
                  <div class="col-lg-3">
                    <input type="text" id="nom" formControlName="name" class="form-control form-control-solid mb-3"
                      placeholder="Poste">
                  </div>
                  <div class="col-lg-3">
                    <div class="combined-input mb-3">
                  
                      <input type="number" formControlName="years_of_experience" oninput="validity.valid||(value='0');"
                        min="0" class="form-control mb-3" placeholder="Années d’expérience"
                        aria-label="Amount (to the nearest dollar)" class="nb1" />
                      <input type="number" formControlName="experience_range" oninput="validity.valid||(value='0');"
                        min="0" class="nb2" value="" placeholder="marge_Années d’expérience" id="marge_année d’exp">

                      <div class="plusetmois">
                        <i class="fa-solid fa-plus-minus"></i>
                      </div>

                    </div>
                  </div>



                

                </div>

                <div class="row" *ngIf="seeMore">
                  <div class="col-lg-3">
                    <ng-select [items]="contrat"  formControlName="contract_type" class="mb-3" [notFoundText]="'Aucun élément trouvé'"
                      bindLabel="name" bindValue="id" [multiple]="true" [placeholder]="'Contrat demandé'" autoComplete>
                    </ng-select>

                  </div>
                  <div class="col-lg-3  ">
                    <div class="combined-input mb-3">
                      <input type="number" min="0" formControlName="tjm" class="nb1" placeholder="TJM" id="tjm">
                      <div class="euro">
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                            fill="#4B4B4B" />
                        </svg>
                      </div>
                      <input type="number" min="0" formControlName="tjm_range" name="number2" class="nb2" value="1"
                        id="marge_tjm">
                      <div class="icon">
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                            fill="#4B4B4B" />
                        </svg>
                      </div>
                      <div class="plusetmois">
                        <i class="fa-solid fa-plus-minus"></i>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <div class="combined-input mb-3">
                      <input type="number" min="0" formControlName="desired_salary" class="nb1" placeholder="Salaire"
                        id="Salaire">
                      <div class="euro">
                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                            fill="#4B4B4B" />
                        </svg>
                      </div>
                      <input type="number" min="0" formControlName="desired_salary_range" name="number2" (change)="alreadyConverted=false"  class="nb2" (input)="onSalaryRangeInput($event)"
                        value="1" id="marge_tjm">
                      <div class="icon">
                        <svg width="20" height="15" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.37 10L1.352 5.548V10H0.0780001V0.242H1.352V4.764L5.384 0.242H6.994L2.57 5.128L7.036 10H5.37Z"
                            fill="#4B4B4B" />
                          <path
                            d="M13.889 8.739C14.435 8.739 14.9117 8.62633 15.319 8.401C15.735 8.167 16.06 7.82467 16.294 7.374H18.075C17.737 8.24067 17.1953 8.908 16.45 9.376C15.7047 9.844 14.851 10.078 13.889 10.078C12.875 10.078 11.9737 9.805 11.185 9.259C10.3963 8.70433 9.846 7.96767 9.534 7.049H8.338V6.035H9.3C9.28267 5.79233 9.274 5.60167 9.274 5.463C9.274 5.32433 9.28267 5.13367 9.3 4.891H8.338V3.877H9.534C9.846 2.95833 10.3963 2.226 11.185 1.68C11.9737 1.12533 12.875 0.847999 13.889 0.847999C14.8423 0.847999 15.6917 1.08633 16.437 1.563C17.191 2.031 17.737 2.69833 18.075 3.565H16.294C16.06 3.11433 15.735 2.77633 15.319 2.551C14.9117 2.317 14.435 2.2 13.889 2.2C13.2563 2.2 12.6973 2.34733 12.212 2.642C11.7353 2.93667 11.3713 3.34833 11.12 3.877H13.889V4.891H10.834C10.808 5.073 10.795 5.26367 10.795 5.463C10.795 5.66233 10.808 5.853 10.834 6.035H13.889V7.049H11.12C11.3713 7.58633 11.7353 8.00233 12.212 8.297C12.6973 8.59167 13.2563 8.739 13.889 8.739Z"
                            fill="#4B4B4B" />
                        </svg>
                      </div>
                      <div class="plusetmois">
                        <i class="fa-solid fa-plus-minus"></i>
                      </div>
                    </div>

                  </div>

                  <div class="col-lg-3">
                    <ng-select formControlName="post_type" [multiple]="true" [items]="postType" bindLabel="name" class="mb-3" [notFoundText]="'Aucun élément trouvé'"
                      bindValue="id" [placeholder]="'Type de poste'" autoComplete>
                    </ng-select>

                  </div>
                  </div>

                <div class="row" *ngIf="seeMore">
                  <div class="col-lg-3">
                    <ng-select [items]="listskills"  bindLabel="name_FR" class="mb-3"
                      formControlName="skillsOr" bindValue="name_FR" [multiple]="true"
                      [placeholder]="'Compétences (ou)'" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                    </ng-select>

                  </div>
                  <div class="col-lg-3">
                    <ng-select [items]="listskills"  formControlName="skillsAnd" class="mb-3"
                      bindLabel="name_FR" bindValue="name_FR" [multiple]="true" [placeholder]="'Compétences (et)'"
                      [notFoundText]="'Aucun élément trouvé'" autoComplete>
                    </ng-select>
                  </div>
                  <div class="col-lg-3">

                    <ng-select [items]="disponibilite"  formControlName="availability" class="mb-3" [notFoundText]="'Aucun élément trouvé'"
                      bindLabel="name" bindValue="id" [multiple]="true" [placeholder]="'Disponibilité'" autoComplete>
                    </ng-select>
                  </div>
                  <div class="col-lg-3">
                    <ng-select (change)="onCountryChange('add');" [items]="paysList" bindLabel="name" [multiple]="true"
                      formControlName="country" bindValue="name" class="mb-3" [placeholder]="'Pays'" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                    </ng-select>
                  </div>





                

                </div>
                <div class="row" *ngIf="seeMore">
                  <div class="col-lg-3">
                    <ng-select [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" bindLabel="name" [multiple]="true" (change)="onMobilityChange('add')"
                      class=" mb-3" formControlName="city" bindValue="name" [placeholder]="'Ville'" 
                      [notFoundText]="'Aucun élément trouvé'" autoComplete>
                    </ng-select>
                  </div>
                  <div class="col-lg-3">
                    <div class="position-relative d-flex align-items-center calenderDate">
                      <!--begin::Datepicker-->
                      <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"  placeholder="Date de début de publication" inputId="yearpicker" 
                        formControlName="start_date" class="form-control"
                       ></p-calendar>
                      <!--end::Datepicker-->
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="position-relative d-flex align-items-center calenderDate">
                      <!--begin::Datepicker-->
                      <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"  placeholder="Date de fin de publication" inputId="yearpicker" 
                      formControlName="end_date" class="form-control"
                     ></p-calendar>
                      <!--end::Datepicker-->
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <ng-select  [items]="profile" bindLabel="name" class=" mb-3" [notFoundText]="'Aucun élément trouvé'"
                      bindValue="id" [placeholder]="'Profil à l\'étranger'" formControlName="profil_étrangers" autoComplete>
                    </ng-select>
                  </div>


                </div>
                <div class="row mb-3" *ngIf="seeMore">
                  <div class="col-lg-3">
                    <ng-select [items]="passeport" bindLabel="name" class=" mb-3" [notFoundText]="'Aucun élément trouvé'"
                      bindValue="id" [placeholder]="'Passeport talent'" formControlName="passeport_talent" autoComplete>
                    </ng-select>
                  </div>
                  <div class="col-lg-3 mb-3">
                    <ng-select [multiple]="true" [items]="Statut" bindLabel="name" formControlName="state" [notFoundText]="'Aucun élément trouvé'"
                      bindValue="id" [placeholder]="'Statut'" autoComplete>
                    </ng-select>
                  </div>

                </div>
                <div class="see-more mb-5">
                  <a class="" (click)="seeMore=!seeMore">Voir {{!seeMore?'plus':'moins'}} de critères de recherche</a>
                </div>

                <div class="mb-3 search-btn d-flex justify-content-end">
                  <div class="align-items-center recherche">
                    <button type="button" class="me-5" (click)="searchCandidat()">
                      <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                          fill="white" />
                      </svg>
                      Rechercher</button>
                  </div>
                  <div class="resett-btn">
                    <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                      title="Réinitialiser">
                      <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt="" width="30px"></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </form>
        </div>
      </div>

      <!--end::Content container-->
    </div>
    <!--begin::Content-->
    <div *ngIf="!isLoadSpinner" id="kt_app_content" class="app-content flex-column-fluid mb-4">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card content-table">
          <div class="d-flex justify-content-between align-items-center">
            <div class="section_title">
              <h1 class="section-heading my-0">Liste des candidatures</h1>
            </div>
            <div class="d-flex flex-wrap flex-stack pt-10 pb-8 title">
              <div class="d-flex flex-wrap my-1">
                <ul class="nav nav-pills me-5">
                  <li class="nav-item m-0">
                    <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3"
                      data-bs-toggle="tab" href="#grid">
                      <i class="ki-duotone ki-element-plus fs-1">
                        <span class="path1"></span>
                        <span class="path2"></span>
                        <span class="path3"></span>
                        <span class="path4"></span>
                        <span class="path5"></span>
                      </i>
                    </a>
                  </li>
                  <li class="nav-item m-0">
                    <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                      data-bs-toggle="tab" href="#list">
                      <i class="ki-duotone ki-row-horizontal fs-2">
                        <span class="path1"></span>
                        <span class="path2"></span>
                      </i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!--begin::Card header-->

          <!--end::Card header-->
          <!--begin::Card body-->
          <div class="tab-content for-web">
            <div id="grid" class="tab-pane fade">
              <!--begin::Row-->
              <div class="row g-6 g-xl-9 justify-content-center cards">
                <!--begin::Col-->
                <div class="col-sm-6 col-xxl-4" *ngFor="let company of listCandidat ; let i =index">
                  <!--begin::Card-->
                  <div class="card pt-5 p-5">
                      <!-- <div class="type-esn">
                        <span *ngIf="company?.company_type=='2'"> Esn</span>
                        <span *ngIf="company?.company_type=='3'"> Client Final</span>
                        <span *ngIf="company?.company_type=='4'"> Cabinet de Recrutement</span>
                        <span *ngIf="!company.company_type">---</span>
                    </div> -->
                      <!-- begin menu action -->
                      <div class="tools">
                        <div class="dropdown">
                          <button
                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                            type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                fill="#265D91" />
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                fill="#265D91" />
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                fill="#265D91" />
                            </svg>
                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" [routerLink]="['/profil-candidats-anonyme',company.candidat_id]">Voir
                              Profil</a>
                              <a  [routerLink]="['/dossier-candidature',company.id,company.candidat_id,1,company.company_apply_id]"
                              class="dropdown-item cursor-pointer" >voir dossier de candidature </a>
                          </div>
                        </div>
                      </div>
                      <!-- end menu action -->
                      <!-- *********************************************************************** -->
                    
                    <!--begin::Card header-->
                    <div class="card-header flex-nowrap border-0 pt-9">
                      <!--begin::Card title-->
                      <div class="card-title m-0">
                        <!--begin::Icon-->
                        <div class="symbol">
                          <img *ngIf="company.candidat_image&&company.candidat_image!='avatar.png'" class="table-img"
                            src="{{url+'/User/file/gallery_users/' + company.candidat_image}}" alt="" width="75px"> 
                        </div>
                        <!--end::Icon-->
                        <!--begin::Title-->
                        <span class="name cursor-pointer" [routerLink]="['/profil-candidats-anonyme',company.candidat_id]" >{{company.candidat_first_name}} 
                          {{company.candidat_last_name}}</span>

                        <!--end::Title-->
                      </div>
                      <!--end::Card title-->
                      <!--begin::Card toolbar-->

                      <!--end::Card toolbar-->
                    </div>
                    <!--end::Card header-->
                    <!--begin::Card body-->
                    <div class="card-body d-flex flex-column px-9 pt-6 pb-8">
                      <!--begin::Heading-->
                      <div class="fw-bold mb-3 mail text-center"> <svg width="15" height="10" viewBox="0 0 15 10"
                          fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M1.51185 0H13.4193C13.8339 0 14.212 0.169447 14.4868 0.443242C14.7611 0.717038 14.9307 1.09327 14.9307 1.50635V8.12962C14.9307 8.54414 14.7606 8.92085 14.4868 9.19369L14.4724 9.20709C14.199 9.47227 13.8272 9.63597 13.4188 9.63597H1.51137C1.0963 9.63597 0.718214 9.46653 0.44438 9.19321C0.170065 8.92085 0 8.54414 0 8.12962V1.50635C0 1.09327 0.170065 0.716559 0.44486 0.442764C0.719655 0.169447 1.09726 0.000478766 1.51185 0.000478766V0ZM1.81691 1.2742L1.55989 1.67772L7.46558 5.42038L13.3708 1.67772L13.1138 1.2742L7.4651 4.85365L1.81643 1.2742H1.81691Z"
                            fill="#265D91" />
                        </svg>
                        {{company.email}}</div>
                      <div class="fw-bold mb-3 phone text-center"><svg width="13" height="16" viewBox="0 0 13 16"
                          fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12.3933 12.9149C12.0867 11.986 11.5346 11.1928 10.7542 10.5586C10.4535 10.3129 10.1549 10.1686 9.84222 10.1178C9.7207 10.0981 9.59605 10.093 9.4714 10.102C9.05836 10.1338 8.64624 10.2571 8.2118 10.4795C8.07498 10.5503 7.91751 10.5713 7.74455 10.5433C7.5336 10.5091 7.31749 10.4 7.1803 10.2584C6.18421 9.23037 5.37914 8.1136 4.71883 6.84499C4.58938 6.59524 4.53609 6.09005 4.83555 5.79797C5.18516 5.45768 5.43317 5.10671 5.59451 4.72519C5.76766 4.31403 5.75899 3.86957 5.56778 3.36769C5.21263 2.42649 4.63419 1.65278 3.84923 1.06715C3.59495 0.877219 3.32278 0.757591 3.03937 0.711397C2.56621 0.634467 2.08974 0.767714 1.66176 1.09623C1.26845 1.39769 0.910722 1.72658 0.494545 2.12742C0.113218 2.4944 0.0604813 2.9812 0.0136452 3.4102L0.0123545 3.41922C-0.0368787 3.96564 0.0606656 4.63703 0.311626 5.47222C0.735916 6.88548 1.43864 8.27611 2.46111 9.72397C2.67113 10.0218 3.5116 11.1873 3.72789 11.4807C4.77912 12.9079 5.87737 14.0151 7.08516 14.8647C7.79913 15.3673 8.40597 15.673 8.94053 15.7996L8.94956 15.8013C9.05983 15.8252 9.17803 15.8504 9.29383 15.8692C9.57945 15.9157 9.95414 15.9444 10.3211 15.7536C10.8343 15.4867 11.2604 15.2524 11.6703 14.9766C12.3909 14.4934 12.6609 13.7225 12.3933 12.9149ZM3.06647 3.48805C2.52196 2.73292 2.36227 1.91835 2.70985 1.66879C3.05744 1.41904 3.78063 1.8289 4.32515 2.58403C4.86966 3.33916 5.02935 4.15373 4.68195 4.4033C4.33418 4.65304 3.61099 4.24318 3.06647 3.48805ZM11.5305 13.9649C11.1829 14.2146 10.4598 13.8048 9.91523 13.0496C9.37072 12.2945 9.21103 11.4799 9.55843 11.2304C9.90583 10.9808 10.6292 11.3905 11.1737 12.1456C11.7184 12.9007 11.8781 13.7153 11.5305 13.9649Z"
                            fill="#265D91" />
                        </svg>
                        {{company.phone_number?company.phone_number:'---'}}</div>
                      <!--end::Heading-->
                      <!--begin::Stats-->

                      <!--end::Stats-->
                      <!--begin::Indicator-->
                      <div class="footer p-5 d-flex">
                        <div class="socials">
                          <span class="badge bg-light text-gray-700 px-3 py-2 me-2">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_426_2396)">
                                <path
                                  d="M14.2669 17.8389H2.84767C1.3399 17.8389 0.113281 16.5429 0.113281 14.9497V2.88923C0.113281 1.296 1.3399 0 2.84767 0H14.2669C15.7742 0 17.0008 1.296 17.0008 2.88923V14.9502C17.0008 16.5434 15.7742 17.8389 14.2669 17.8389ZM5.81961 14.7475H5.8231V7.05277H3.5621V14.7475H5.81918H5.81961ZM4.69108 6.00185C4.86298 6.00209 5.03325 5.96642 5.19211 5.89687C5.35098 5.82733 5.49532 5.72528 5.61688 5.59657C5.73844 5.46787 5.83482 5.31503 5.9005 5.14682C5.96618 4.97861 5.99987 4.79833 5.99964 4.61631C5.99895 4.24906 5.86086 3.89707 5.61561 3.63739C5.37035 3.37771 5.03792 3.2315 4.69108 3.23077C4.34406 3.23089 4.01129 3.37691 3.76591 3.63672C3.52053 3.89653 3.38263 4.24888 3.38251 4.61631C3.38263 4.98374 3.52053 5.33608 3.76591 5.5959C4.01129 5.85571 4.34406 6.00172 4.69108 6.00185ZM14.2799 14.748V10.5295C14.2799 8.45677 13.8549 6.86215 11.5708 6.86215C10.4728 6.86215 9.73572 7.49908 9.43277 8.10369H9.40226V7.05277H7.23715V14.7475H9.49423V10.9398C9.49423 9.93554 9.67425 8.964 10.8499 8.964C12.0059 8.964 12.0229 10.1123 12.0229 11.0045V14.7475H14.2799V14.748Z"
                                  fill="#265D91" />
                              </g>
                              <defs>
                                <clipPath id="clip0_426_2396">
                                  <rect width="17" height="18" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>

                          </span>
                          <span class="text-gray-400 fs-7">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <rect x="0.0410156" y="0.0407715" width="17.9592" height="17.9592" rx="3"
                                fill="#265D91" />
                              <path
                                d="M8.72077 14.4082C5.4083 14.4082 2.73438 12.0017 2.73438 9.02045C2.73438 6.03922 5.4083 3.63269 8.72077 3.63269C12.0332 3.63269 14.7072 6.03922 14.7072 9.02045C14.7072 12.0017 12.0332 14.4082 8.72077 14.4082ZM8.72077 4.35106C5.8473 4.35106 3.53256 6.43432 3.53256 9.02045C3.53256 11.6066 5.8473 13.6898 8.72077 13.6898C11.5942 13.6898 13.909 11.6066 13.909 9.02045C13.909 6.43432 11.5942 4.35106 8.72077 4.35106Z"
                                fill="white" />
                              <path
                                d="M11.833 10.3494C11.9128 9.91841 11.9128 9.48738 11.9128 9.02045C11.9128 8.55351 11.8729 8.12249 11.833 7.69147C11.7532 7.11677 11.5936 6.578 11.4339 6.07514C10.8353 4.60249 9.87746 3.63269 8.72009 3.63269C7.36317 3.63269 6.24571 4.96167 5.7668 6.90126C5.72689 7.08085 5.68698 7.22453 5.64707 7.40412C5.56725 7.90698 5.52734 8.44575 5.52734 9.02045C5.52734 9.48738 5.56725 9.91841 5.60716 10.3494C5.68698 10.9241 5.84662 11.4629 6.00626 11.9658C6.56499 13.4384 7.56272 14.4082 8.68018 14.4082C9.79764 14.4082 10.7954 13.4384 11.3541 11.9658C11.0747 12.0376 10.7555 12.0735 10.4362 12.1453C10.0371 13.1151 9.35864 13.6898 8.72009 13.6898C8.08154 13.6898 7.40308 13.1151 6.96408 12.1453C6.76453 11.7143 6.60489 11.1755 6.48517 10.6009C6.36544 10.098 6.32553 9.59514 6.32553 9.02045C6.32553 8.44575 6.36544 7.90698 6.48517 7.44004C6.52508 7.26045 6.56499 7.11677 6.60489 6.93718V6.90126C6.6448 6.72167 6.68471 6.578 6.76453 6.43432C6.80444 6.32657 6.84435 6.21881 6.88426 6.14698C6.88426 6.14698 6.88426 6.14698 6.88426 6.11106L6.96408 5.96738C6.96408 5.96738 6.96408 5.93147 7.00399 5.89555C7.40308 4.92575 8.08154 4.35106 8.72009 4.35106C9.35864 4.35106 10.0371 4.92575 10.4761 5.89555C10.6756 6.32657 10.8353 6.86534 10.955 7.44004C11.0747 7.94289 11.1146 8.44575 11.1146 9.02045C11.1146 9.59514 11.0747 10.098 10.9949 10.6009C11.2743 10.529 11.5536 10.4572 11.833 10.3494Z"
                                fill="white" />
                              <path
                                d="M11.9933 6.61416C11.4745 6.43456 10.836 6.32681 10.1974 6.25497C9.7185 6.18314 9.23959 6.14722 8.72077 6.14722C8.20195 6.14722 7.72304 6.18314 7.24412 6.21905C7.16431 6.43456 7.04458 6.68599 6.96476 6.97334C7.52349 6.9015 8.08222 6.86558 8.72077 6.86558C9.35932 6.86558 9.91805 6.9015 10.4768 6.97334C11.1153 7.08109 11.714 7.22477 12.1929 7.40436C13.2704 7.83538 13.909 8.41007 13.909 8.98477C13.909 9.55946 13.2704 10.1701 12.1929 10.5652C11.714 10.7448 11.1153 10.8884 10.4768 10.9962C9.91805 11.1399 9.35932 11.1758 8.72077 11.1758C8.08222 11.1758 7.52349 11.1399 6.96476 11.0321C6.32621 10.9603 5.72757 10.8166 5.24866 10.6011C4.17111 10.206 3.53256 9.59538 3.53256 9.02069C3.53256 8.44599 4.17111 7.83538 5.24866 7.44028C5.28857 7.15293 5.36839 6.86558 5.44821 6.61416C3.81193 7.11701 2.73438 7.97905 2.73438 9.02069C2.73438 10.0623 3.81193 10.9244 5.44821 11.4272C5.96703 11.6068 6.60558 11.7146 7.24412 11.7864C7.72304 11.8582 8.20195 11.8582 8.72077 11.8582C9.23959 11.8582 9.7185 11.8223 10.1974 11.7864C10.836 11.7146 11.4745 11.5709 11.9933 11.4272C13.6296 10.9244 14.7072 10.0264 14.7072 9.02069C14.7072 8.01497 13.6296 7.11701 11.9933 6.61416Z"
                                fill="white" />
                            </svg>

                          </span>
                        </div>

                        <div class="details cursor-pointer">
                          <a class="cursor-pointer"  routerLink="/detail-offre/{{company.id}}" >Voir détail</a>
                        </div>
                      </div>
                      <!--end::Indicator-->
                    </div>

                    <!--end::Card body-->
                  </div>
                  <!--end::Card-->
                </div>
                <!--end::Col-->
                <!--begin::Col-->


                <!--end::Col-->


              </div>
              <!--end::Row-->
            </div>
            <div id="list" class="tab-pane fade show active">
              <div class="card-body pt-0 padding-s">
                <!--begin::Table-->
                <div class="table-responsive" id="kt_customers_table">
                  <table class="table align-middle gy-5 style-table" >
                    <thead>
                      <tr class="text-start text-gray-400 fw-bold  text-uppercase gs-0">
                        <th class="min-w-125px"><span>ID offre <i class="fa-solid fa-sort cursor-pointer" (click)="sortData('ID_jobRequest')" ></i></span> </th>
                        <th class="min-w-125px th-fixed"><span>Entreprise <i class="fa-solid fa-sort cursor-pointer"  (click)="sortData('company_name')"></i></span></th>
                        <th class="min-w-175px"><span>Nature</span></th>
                        <th class="min-w-175px"><span>nom candidat<i class="fa-solid fa-sort cursor-pointer"(click)="sortData('candidat_first_name')"></i></span></th>
                        <th class="min-w-125px th-fixed2"><span>Poste<i class="fa-solid fa-sort cursor-pointer"(click)="sortData('name')"></i></span></th>
                        <th class="min-w-175px"><span>Date de candidatures<i class="fa-solid fa-sort cursor-pointer"(click)="sortData('date_postule')"></i></span></th>
                        <th class="min-w-175px"><span>Années d’expérience<i class="fa-solid fa-sort cursor-pointer"(click)="sortData('years_of_experience')"></i></span></th>
                        <th class="min-w-125px"><span>Type de contrat<i class="fa-solid fa-sort cursor-pointer"(click)="sortData('contract_type')"></i></span></th>
                        <th class="min-w-150px"><span>Salaire demandé<i class="fa-solid fa-sort cursor-pointer"  (click)="sortData('salary')"></i></span></th>
                        <th class="min-w-125px"><span>TJM demandé<i class="fa-solid fa-sort cursor-pointer" (click)="sortData('tjm')"></i></span></th>
                        <th class="min-w-125px"><span>Type de poste<i class="fa-solid fa-sort cursor-pointer"  (click)="sortData('post_type')"></i></span></th>
                        <th class="min-w-125px"><span>Compétences</span></th>
                        <th class="min-w-125px"><span>disponibilité<i class="fa-solid fa-sort cursor-pointer" (click)="sortData('availability')"></i></span></th>
                        <th class="min-w-175px"><span>Score Wegestu<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-175px"><span>Score Client<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-150px"><span>Statut</span></th>
                        <th class="min-w-70px"><span>Actions</span></th>
                        <th class="min-w-70px">
                          <div class="dropdown">
                            <button
                              class="dropdown-toggle"
                              type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                              aria-expanded="false">
                              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"
                                fill="none">
                                <g filter="url(#filter0_d_588_1699)">
                                  <rect x="4" width="20" height="20" rx="4" fill="#63C3E8" fill-opacity="0.12"
                                    shape-rendering="crispEdges" />
                                </g>
                                <path
                                  d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                  fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                                <defs>
                                  <filter id="filter0_d_588_1699" x="0" y="0" width="28" height="28"
                                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="4" />
                                    <feGaussianBlur stdDeviation="2" />
                                    <feComposite in2="hardAlpha" operator="out" />
                                    <feColorMatrix type="matrix"
                                      values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                      result="effect1_dropShadow_588_1699" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_588_1699"
                                      result="shape" />
                                  </filter>
                                </defs>
                              </svg>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <div class="d-flex checkbox mb-2 menu" *ngFor="let item of dataHeader;let i =index">
                                <div class="form-check form-check-sm form-check-custom form-check-solid"
                                  *ngIf="item.name!='checkbox'">

                                  <input class="form-check-input checkbox-border"
                                  [checked]="(item.checked=='oui'&&!item.checked_user)||item.checked_user=='oui'&&(item.checked=='non'||item.checked=='oui')"
                                   type="checkbox" value="1" />
                                  <a class="dropdown-item">{{item.name}}</a>
                                </div>
                              </div>
                            </div>

                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody class="fw-semibold text-gray-600">

                      <tr *ngFor="let company of listCandidat ; let i =index">
                        <td>

                          <a class="first-td" routerLink="/detail-offre/{{company.id}}">{{company.ID_jobRequest?company.ID_jobRequest:'---'}}</a>
                        </td>
                        <td class="cursor-pointer td-fixed"><a routerLink="/entreprises/details-entreprise/{{company.company_id}}">
                          <span class="first-td"> {{company.company_name?company.company_name:'---'}}</span></a>
                        </td>
                        <td>
                          <span class="wrapping" [ngClass]="company?.company_type=='1'?'type-data':company.company_type=='2'?
                          'esn-type':company.company_type=='3'?'client-type':'centre-type'">
                            {{company?.company_type=='1'?'Entrepeise':company.company_type=='2'?
                            'ESN':company.company_type=='3'?'Client Final':'Cabinet de Recrutement'}}</span>
                        </td>
                        <td>
                          <a class="cursor-pointer first-td"  [routerLink]="['/profil-candidats-anonyme',company.candidat_id]">
                            {{company.candidat_first_name?company.candidat_first_name:'---'}}
                            {{company.candidat_last_name?company.candidat_last_name:'---'}}</a>
                        </td>
                        <td class="cursor-pointer td-fixed2"><a  routerLink="/detail-offre/{{company.id}}"
                            class="cursor-pointer"><span class="first-td">{{company.name?company.name:'---'}}</span></a></td>
                        <td><span>{{formatDate(company.date_postule)}}</span></td>

                        <td> <span> {{company.years_of_experience?company.years_of_experience:'---'}} ans </span></td>
                        <td>
                          <div *ngFor="let contractType of company.contract_type">
                            <span>{{
                                contratTypeOptions[contractType] }}</span>
                        </div>
                       
                        <span   *ngIf="company.contract_type===null">---</span> 
                          
                        </td>
                        <td>
                          <span *ngIf="company.salary && company.salary!==null && company.salary!=='null'&& company.salary!=='0'">{{company.salary +'&euro;'}}</span>
                          <span *ngIf="!company.salary || company.salary===null || company.salary==='null'||company.salary==='0'">---</span>
                        </td>

                        <td>
                          <span *ngIf="company.tjm  && company.tjm!==null && company.tjm!=='null'&& company.tjm!=='0'">{{company.tjm + '&euro;'}}</span>
                          <span *ngIf="!company.tjm || company.tjm===null || company.tjm==='null'||company.tjm==='0'">---</span>
                        </td>


                        <td>
                                                             <span *ngIf="company.post_type==1"
                                                                class="badge badge-type hybride-badge">sur site</span>
                                                            <span *ngIf="company.post_type==2"
                                                                class="badge badge-type sur-site-badge">à
                                                                distance</span>
                                                            <span *ngIf="company.post_type==3"
                                                                class="badge badge-type teletravail-badge">hybrid</span>
                                                                <span *ngIf="company.post_type===null">---</span>
                        </td>


                        <td>
                          <div class="skills">
                            <ng-container *ngFor="let skill of company.skills_job.slice(0,2)">
                              <span>
                                <div class="laravel">
                                  {{skill?.sub_category?.name_FR?skill?.sub_category?.name_FR:'---'}}</div>
                              </span>

                            </ng-container>
                            <span *ngIf="company.skills_job?.length&&company.skills_job?.length>2"><svg width="8"
                                height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M7.34144 4.86849H4.51344V7.76649H3.02944V4.86849H0.201438V3.52449H3.02944V0.626487H4.51344V3.52449H7.34144V4.86849Z"
                                  fill="#ACA7A7" />
                              </svg>
                            </span>
                          </div>
                        </td>


                        <td>
                          <span class="color-blue">{{
                            availabilituyTypeOptions[company.availability] }}</span>
                              <span *ngIf="company.availability===null">---</span>
                          </td>

                 
                          <td>
                            <div class="d-flex align-items-center flex-column mt-3 w-100">
                              <div class="d-flex justify-content-center w-100 mt-auto mb-2">
                                <span class="fw-bold fs-6 text-gray-400">{{ company.scoreWegestu? company.scoreWegestu+ '%' : '---'
                                }}</span>
                              </div>
  
                              <div class="h-8px mx-3 w-100 bg-light-success rounded">
                                <div class="bg-success rounded h-8px" role="progressbar"
                                  [style.width.%]="company.scoreWegestu? company.scoreWegestu: 0" aria-valuemin="0"
                                  aria-valuemax="100">
                                </div>
                              </div>
                            </div>
                          </td>
                          
                          <td>
                            <div class="d-flex align-items-center flex-column mt-3 w-100">
                              <div class="d-flex justify-content-center w-100 mt-auto mb-2">
                                <span class="fw-bold fs-6 text-gray-400">{{ company.scoreClient? company.scoreClient+ '%' : '---'
                                  }}</span>
                              </div>
  
                              <div class="h-8px mx-3 w-100 bg-light-success rounded">
                                <div class="bg-success rounded h-8px" role="progressbar"
                                  [style.width.%]="company.scoreClient ? company.scoreClient : 0" aria-valuemin="0"
                                  aria-valuemax="100">
                                </div>
                              </div>
                            </div>
                          </td>
                        <td *ngIf="company.state === 0">
                          <span class="actif">
                            <i class="fa-solid fa-circle"></i> Actif
                          </span>
                        </td>
                        <td *ngIf="company.state === 1">
                          <span class="badge desactif"> <i class="fa-solid fa-circle"></i> Non Actif</span>

                        </td>

                        <td>
                          
                          <div class="tools">
                            <div class="dropdown">
                                <button
                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                    type="button" id="dropdownMenuButton"
                                    data-bs-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">
                                    <svg width="19" height="5" viewBox="0 0 19 5"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                            transform="matrix(1 0 0 -1 0 4.89478)"
                                            fill="#265D91" />
                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                            transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                            fill="#265D91" />
                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                            transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                            fill="#265D91" />
                                    </svg>
                                </button>
                                <div class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" routerLink="/detail-offre/{{company.id}}">Voir
                                        Profil</a>
                                        <!-- (click)="openModal(send,company)" -->
                                        <a  [routerLink]="['/dossier-candidature',company.id,company.candidat_id,1,company.company_apply_id]"
                                        class="dropdown-item cursor-pointer" >voir dossier de candidature </a>
                                    

                                </div>
                            </div>
                          </div>
                        </td>








                      </tr>

                    </tbody>
                  </table>
                </div>

                <div class="alert alert-warning text-center mt-5" role="alert"
                *ngIf="!listCandidat?.length && !loadSpinnerTable">
                <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                <span class="empty-list">
                  La liste est vide
                </span>
              </div>
              <div class="pagination" *ngIf="listCandidat && listCandidat.length">
                <app-pagination [data]="listCandidat" [lengthData]="totalItems" [currentPageList]="currentPage"  (setPages)="getItems($event)">
                </app-pagination>
              </div>
                <!--end::Table-->
              </div>
            </div>

          </div>


          <div class="tab-content for-mobile">
            <div id="grid" class="tab-pane fade show active">
              <!--begin::Row-->
              <div class="row g-6 g-xl-9 justify-content-center cards">
                <!--begin::Col-->
                <div class="col-sm-6 col-xl-4" *ngFor="let company of listCandidat ; let i =index">
                  <!--begin::Card-->
                  <div class="card h-100">
                    <div class="card-toolbar m-0">
                      <!-- begin menu action -->
                      <div class="tools">
                        <div class="dropdown">
                          <button
                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                            type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                fill="#265D91" />
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                fill="#265D91" />
                              <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                fill="#265D91" />
                            </svg>
                          </button>
                          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" [routerLink]="['/candidats/profil-candidat']">Voir
                              Profil</a>
                            <a class="dropdown-item">Re-valider</a>
                            <a class="dropdown-item">Re-tester</a>
                          </div>
                        </div>
                      </div>
                      <!-- end menu action -->
                      <!-- *********************************************************************** -->
                    </div>
                    <!--begin::Card header-->
                    <div class="card-header flex-nowrap border-0 pt-9">
                      <!--begin::Card title-->
                      <div class="card-title m-0">
                        <!--begin::Icon-->
                        <div class="symbol">
                          <img *ngIf="company.candidat_image&&company.candidat_image!='avatar.png'" class="table-img"
                            src="{{url+'/User/file/gallery_users/' + company.candidat_image}}" alt="" width="75px"> <img
                            src="/assets/media/icons/avatar.jpg" alt="" width="50px">
                        </div>
                        <!--end::Icon-->
                        <!--begin::Title-->
                        <span class="name">{{company.candidat_first_name}}
                          {{company.candidat_last_name}}</span>

                        <!--end::Title-->
                      </div>
                      <!--end::Card title-->
                      <!--begin::Card toolbar-->

                      <!--end::Card toolbar-->
                    </div>
                    <!--end::Card header-->
                    <!--begin::Card body-->
                    <div class="card-body d-flex flex-column px-9 pt-6 pb-8">
                      <!--begin::Heading-->
                      <div class="fw-bold mb-3 mail text-center"> <svg width="15" height="10" viewBox="0 0 15 10"
                          fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M1.51185 0H13.4193C13.8339 0 14.212 0.169447 14.4868 0.443242C14.7611 0.717038 14.9307 1.09327 14.9307 1.50635V8.12962C14.9307 8.54414 14.7606 8.92085 14.4868 9.19369L14.4724 9.20709C14.199 9.47227 13.8272 9.63597 13.4188 9.63597H1.51137C1.0963 9.63597 0.718214 9.46653 0.44438 9.19321C0.170065 8.92085 0 8.54414 0 8.12962V1.50635C0 1.09327 0.170065 0.716559 0.44486 0.442764C0.719655 0.169447 1.09726 0.000478766 1.51185 0.000478766V0ZM1.81691 1.2742L1.55989 1.67772L7.46558 5.42038L13.3708 1.67772L13.1138 1.2742L7.4651 4.85365L1.81643 1.2742H1.81691Z"
                            fill="#265D91" />
                        </svg>
                        {{company.email}}</div>
                      <div class="fw-bold mb-3 phone text-center"><svg width="13" height="16" viewBox="0 0 13 16"
                          fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M12.3933 12.9149C12.0867 11.986 11.5346 11.1928 10.7542 10.5586C10.4535 10.3129 10.1549 10.1686 9.84222 10.1178C9.7207 10.0981 9.59605 10.093 9.4714 10.102C9.05836 10.1338 8.64624 10.2571 8.2118 10.4795C8.07498 10.5503 7.91751 10.5713 7.74455 10.5433C7.5336 10.5091 7.31749 10.4 7.1803 10.2584C6.18421 9.23037 5.37914 8.1136 4.71883 6.84499C4.58938 6.59524 4.53609 6.09005 4.83555 5.79797C5.18516 5.45768 5.43317 5.10671 5.59451 4.72519C5.76766 4.31403 5.75899 3.86957 5.56778 3.36769C5.21263 2.42649 4.63419 1.65278 3.84923 1.06715C3.59495 0.877219 3.32278 0.757591 3.03937 0.711397C2.56621 0.634467 2.08974 0.767714 1.66176 1.09623C1.26845 1.39769 0.910722 1.72658 0.494545 2.12742C0.113218 2.4944 0.0604813 2.9812 0.0136452 3.4102L0.0123545 3.41922C-0.0368787 3.96564 0.0606656 4.63703 0.311626 5.47222C0.735916 6.88548 1.43864 8.27611 2.46111 9.72397C2.67113 10.0218 3.5116 11.1873 3.72789 11.4807C4.77912 12.9079 5.87737 14.0151 7.08516 14.8647C7.79913 15.3673 8.40597 15.673 8.94053 15.7996L8.94956 15.8013C9.05983 15.8252 9.17803 15.8504 9.29383 15.8692C9.57945 15.9157 9.95414 15.9444 10.3211 15.7536C10.8343 15.4867 11.2604 15.2524 11.6703 14.9766C12.3909 14.4934 12.6609 13.7225 12.3933 12.9149ZM3.06647 3.48805C2.52196 2.73292 2.36227 1.91835 2.70985 1.66879C3.05744 1.41904 3.78063 1.8289 4.32515 2.58403C4.86966 3.33916 5.02935 4.15373 4.68195 4.4033C4.33418 4.65304 3.61099 4.24318 3.06647 3.48805ZM11.5305 13.9649C11.1829 14.2146 10.4598 13.8048 9.91523 13.0496C9.37072 12.2945 9.21103 11.4799 9.55843 11.2304C9.90583 10.9808 10.6292 11.3905 11.1737 12.1456C11.7184 12.9007 11.8781 13.7153 11.5305 13.9649Z"
                            fill="#265D91" />
                        </svg>
                        {{company.phone_number?company.phone_number:'---'}}</div>
                      <!--end::Heading-->
                      <!--begin::Stats-->

                      <!--end::Stats-->
                      <!--begin::Indicator-->
                      <div class="footer p-5 d-flex">
                        <div class="socials">
                          <span class="badge bg-light text-gray-700 px-3 py-2 me-2">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_426_2396)">
                                <path
                                  d="M14.2669 17.8389H2.84767C1.3399 17.8389 0.113281 16.5429 0.113281 14.9497V2.88923C0.113281 1.296 1.3399 0 2.84767 0H14.2669C15.7742 0 17.0008 1.296 17.0008 2.88923V14.9502C17.0008 16.5434 15.7742 17.8389 14.2669 17.8389ZM5.81961 14.7475H5.8231V7.05277H3.5621V14.7475H5.81918H5.81961ZM4.69108 6.00185C4.86298 6.00209 5.03325 5.96642 5.19211 5.89687C5.35098 5.82733 5.49532 5.72528 5.61688 5.59657C5.73844 5.46787 5.83482 5.31503 5.9005 5.14682C5.96618 4.97861 5.99987 4.79833 5.99964 4.61631C5.99895 4.24906 5.86086 3.89707 5.61561 3.63739C5.37035 3.37771 5.03792 3.2315 4.69108 3.23077C4.34406 3.23089 4.01129 3.37691 3.76591 3.63672C3.52053 3.89653 3.38263 4.24888 3.38251 4.61631C3.38263 4.98374 3.52053 5.33608 3.76591 5.5959C4.01129 5.85571 4.34406 6.00172 4.69108 6.00185ZM14.2799 14.748V10.5295C14.2799 8.45677 13.8549 6.86215 11.5708 6.86215C10.4728 6.86215 9.73572 7.49908 9.43277 8.10369H9.40226V7.05277H7.23715V14.7475H9.49423V10.9398C9.49423 9.93554 9.67425 8.964 10.8499 8.964C12.0059 8.964 12.0229 10.1123 12.0229 11.0045V14.7475H14.2799V14.748Z"
                                  fill="#265D91" />
                              </g>
                              <defs>
                                <clipPath id="clip0_426_2396">
                                  <rect width="17" height="18" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>

                          </span>
                          <span class="text-gray-400 fs-7">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <rect x="0.0410156" y="0.0407715" width="17.9592" height="17.9592" rx="3"
                                fill="#265D91" />
                              <path
                                d="M8.72077 14.4082C5.4083 14.4082 2.73438 12.0017 2.73438 9.02045C2.73438 6.03922 5.4083 3.63269 8.72077 3.63269C12.0332 3.63269 14.7072 6.03922 14.7072 9.02045C14.7072 12.0017 12.0332 14.4082 8.72077 14.4082ZM8.72077 4.35106C5.8473 4.35106 3.53256 6.43432 3.53256 9.02045C3.53256 11.6066 5.8473 13.6898 8.72077 13.6898C11.5942 13.6898 13.909 11.6066 13.909 9.02045C13.909 6.43432 11.5942 4.35106 8.72077 4.35106Z"
                                fill="white" />
                              <path
                                d="M11.833 10.3494C11.9128 9.91841 11.9128 9.48738 11.9128 9.02045C11.9128 8.55351 11.8729 8.12249 11.833 7.69147C11.7532 7.11677 11.5936 6.578 11.4339 6.07514C10.8353 4.60249 9.87746 3.63269 8.72009 3.63269C7.36317 3.63269 6.24571 4.96167 5.7668 6.90126C5.72689 7.08085 5.68698 7.22453 5.64707 7.40412C5.56725 7.90698 5.52734 8.44575 5.52734 9.02045C5.52734 9.48738 5.56725 9.91841 5.60716 10.3494C5.68698 10.9241 5.84662 11.4629 6.00626 11.9658C6.56499 13.4384 7.56272 14.4082 8.68018 14.4082C9.79764 14.4082 10.7954 13.4384 11.3541 11.9658C11.0747 12.0376 10.7555 12.0735 10.4362 12.1453C10.0371 13.1151 9.35864 13.6898 8.72009 13.6898C8.08154 13.6898 7.40308 13.1151 6.96408 12.1453C6.76453 11.7143 6.60489 11.1755 6.48517 10.6009C6.36544 10.098 6.32553 9.59514 6.32553 9.02045C6.32553 8.44575 6.36544 7.90698 6.48517 7.44004C6.52508 7.26045 6.56499 7.11677 6.60489 6.93718V6.90126C6.6448 6.72167 6.68471 6.578 6.76453 6.43432C6.80444 6.32657 6.84435 6.21881 6.88426 6.14698C6.88426 6.14698 6.88426 6.14698 6.88426 6.11106L6.96408 5.96738C6.96408 5.96738 6.96408 5.93147 7.00399 5.89555C7.40308 4.92575 8.08154 4.35106 8.72009 4.35106C9.35864 4.35106 10.0371 4.92575 10.4761 5.89555C10.6756 6.32657 10.8353 6.86534 10.955 7.44004C11.0747 7.94289 11.1146 8.44575 11.1146 9.02045C11.1146 9.59514 11.0747 10.098 10.9949 10.6009C11.2743 10.529 11.5536 10.4572 11.833 10.3494Z"
                                fill="white" />
                              <path
                                d="M11.9933 6.61416C11.4745 6.43456 10.836 6.32681 10.1974 6.25497C9.7185 6.18314 9.23959 6.14722 8.72077 6.14722C8.20195 6.14722 7.72304 6.18314 7.24412 6.21905C7.16431 6.43456 7.04458 6.68599 6.96476 6.97334C7.52349 6.9015 8.08222 6.86558 8.72077 6.86558C9.35932 6.86558 9.91805 6.9015 10.4768 6.97334C11.1153 7.08109 11.714 7.22477 12.1929 7.40436C13.2704 7.83538 13.909 8.41007 13.909 8.98477C13.909 9.55946 13.2704 10.1701 12.1929 10.5652C11.714 10.7448 11.1153 10.8884 10.4768 10.9962C9.91805 11.1399 9.35932 11.1758 8.72077 11.1758C8.08222 11.1758 7.52349 11.1399 6.96476 11.0321C6.32621 10.9603 5.72757 10.8166 5.24866 10.6011C4.17111 10.206 3.53256 9.59538 3.53256 9.02069C3.53256 8.44599 4.17111 7.83538 5.24866 7.44028C5.28857 7.15293 5.36839 6.86558 5.44821 6.61416C3.81193 7.11701 2.73438 7.97905 2.73438 9.02069C2.73438 10.0623 3.81193 10.9244 5.44821 11.4272C5.96703 11.6068 6.60558 11.7146 7.24412 11.7864C7.72304 11.8582 8.20195 11.8582 8.72077 11.8582C9.23959 11.8582 9.7185 11.8223 10.1974 11.7864C10.836 11.7146 11.4745 11.5709 11.9933 11.4272C13.6296 10.9244 14.7072 10.0264 14.7072 9.02069C14.7072 8.01497 13.6296 7.11701 11.9933 6.61416Z"
                                fill="white" />
                            </svg>

                          </span>
                        </div>

                        <div class="details cursor-pointer">
                          <a class="cursor-pointer" class="first-td" routerLink="/detail-offre/{{company.id}}">Voir détail</a>
                        </div>
                      </div>
                      <!--end::Indicator-->
                    </div>

                    <!--end::Card body-->
                  </div>
                  <!--end::Card-->
                </div>
                <!--end::Col-->
                <!--begin::Col-->


                <!--end::Col-->
                <div class="alert alert-warning text-center mt-5" role="alert"
                *ngIf="!listCandidat?.length && !loadSpinnerTable">
                <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                <span class="empty-list">
                  La liste est vide
                </span>
              </div>
              <div class="pagination" *ngIf="listCandidat && listCandidat.length">
                <app-pagination [data]="listCandidat" [lengthData]="totalItems" [currentPageList]="currentPage"  (setPages)="getItems($event)">
                </app-pagination>
              </div>

              </div>
              <!--end::Row-->
            </div>
            <div id="list" class="tab-pane fade ">
              <div class="card-body pt-0 padding-s">
                <!--begin::Table-->
                <div class="table-responsive">
                  <table class="table align-middle fs-6 gy-5 style-table" id="kt_customers_table">
                    <thead>
                      <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                        <th class="min-w-125px"><span>ID offre <i class="fa-solid fa-sort"></i></span> </th>
                        <th class="min-w-125px"><span>Entreprise <i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-175px"><span>Nature</span></th>
                        <th class="min-w-175px"><span>nom candidat<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-125px"><span>Poste<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-175px"><span>Date de candidatures<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-175px"><span>Années d’expérience<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-125px"><span>Type de contrat<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-150px"><span>Salaire demandé<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-125px"><span>TJM demandé<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-125px"><span>Type de poste<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-125px"><span>Compétences<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-125px"><span>disponibilité<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-175px"><span>Score Wegestu<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-175px"><span>Score Client<i class="fa-solid fa-sort"></i></span></th>
                        <th class="min-w-150px"><span>Statut</span></th>
                        <th class="min-w-70px"><span>Actions</span></th>

                      </tr>
                    </thead>
                    <tbody class="fw-semibold text-gray-600">

                      <tr *ngFor="let company of listCandidat ; let i =index">
                        <td>
                          <a class="first-td" routerLink="/detail-offre/{{company.id}}">{{company.ID_jobRequest?company.ID_jobRequest:'---'}}</a>
                        </td>
                        <td class="cursor-pointer " ><a routerLink="/entreprises/details-entreprise/{{company.company_id}}">
                          <span class="first-td"> {{company.company_name?company.company_name:'---'}}</span></a>
                        </td>
                        <td>
                          <span class="wrapping" [ngClass]="company?.company_type=='1'?'type-data':company.company_type=='2'?
                          'esn-type':company.company_type=='3'?'client-type':'cabinet-type'">
                            {{company?.company_type=='1'?'Entrepeise':company.company_type=='2'?
                            'ESN':company.company_type=='3'?'Client Final':'Cabinet de Recrutement'}}</span>
                        </td>
                        <td>
                          <span class="cursor-pointer first-td"  [routerLink]="['/profil-candidats-anonyme',company.candidat_id]">
                            {{company.candidat_first_name?company.candidat_first_name:'---'}}
                            {{company.candidat_last_name?company.candidat_last_name:'---'}}</span>
                        </td>
                        <td><a class="first-td" routerLink="/detail-offre/{{company.id}}"
                            class="cursor-pointer">{{company.name?company.name:'---'}}</a></td>
                        <td><span>{{formatDate(company.updated_at)}}</span></td>

                        <td> <span> {{company.years_of_experience?company.years_of_experience:'---'}} ans </span></td>
                        <td>
                          <div *ngFor="let contractType of company.contract_type">
                            <span class="color-blue">{{ contratTypeOptions[contractType] }}</span>
                          </div>
                        </td>
                        <td>
                          <span> {{company.salary?company.salary:'---'}}</span>
                        </td>

                        <td>
                          <span> {{company.tjm?company.tjm:'---'}}</span>
                        </td>


                        <td>
                          <span *ngIf="company.post_type==1" class="badge badge-type hybride-badge">sur site</span>
                          <span *ngIf="company.post_type==2" class="badge badge-type sur-site-badge">à distance</span>
                          <span *ngIf="company.post_type==3" class="badge badge-type teletravail-badge">hybrid</span>
                          <span *ngIf="company?.post_type==4" class="badge badge-type teletravail-badge">----</span>
                        </td>


                        <td>
                          <div class="skills">
                            <ng-container *ngFor="let skill of company.skills_job.slice(0,2)">
                              <span>
                                <div class="laravel">
                                  {{skill?.sub_category?.name_FR?skill?.sub_category?.name_FR:'---'}}</div>
                              </span>
               

                            </ng-container>
                            <span *ngIf="company.skills_job?.length&&company.skills_job?.length>2"><svg width="8"
                                height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M7.34144 4.86849H4.51344V7.76649H3.02944V4.86849H0.201438V3.52449H3.02944V0.626487H4.51344V3.52449H7.34144V4.86849Z"
                                  fill="#ACA7A7" />
                              </svg>
                            </span>
                          </div>
                        </td>


                        <td><span class="color-blue">{{ availabilituyTypeOptions[company.availability] }}</span></td>

                        <td>
                          <div class="d-flex align-items-center flex-column mt-3 w-100">
                            <div class="d-flex justify-content-center w-100 mt-auto mb-2">
                              <span class="fw-bold fs-6 text-gray-400">{{ company.scoreWegestu}}</span>
                            </div>

                            <div class="h-8px mx-3 w-100 bg-light-success rounded">
                              <div class="bg-success rounded h-8px" role="progressbar"
                                [style.width.%]="company.scoreWegestu? company.scoreWegestu: 0" aria-valuemin="0"
                                aria-valuemax="100">
                              </div>
                            </div>
                          </div>
                        </td>
                        
                        <td>
                          <div class="d-flex align-items-center flex-column mt-3 w-100">
                            <div class="d-flex justify-content-center w-100 mt-auto mb-2">
                              <span class="fw-bold fs-6 text-gray-400">{{ company.scoreClient? company.scoreClient+ '%' : '---'
                                }}</span>
                            </div>

                            <div class="h-8px mx-3 w-100 bg-light-success rounded">
                              <div class="bg-success rounded h-8px" role="progressbar"
                                [style.width.%]="company.score ? company.score : 0" aria-valuemin="0"
                                aria-valuemax="100">
                              </div>
                            </div>
                          </div>
                        </td>
                        <td *ngIf="company.state === 0">
                          <span class="actif">
                            <i class="fa-solid fa-circle"></i> Actif
                          </span>
                        </td>
                        <td *ngIf="company.state === 1">
                          <span class="badge desactif"> <i class="fa-solid fa-circle"></i> Non Actif</span>

                        </td>

                        <td>
                          <div class="seemore">
                            <a routerLink="/detail-offre/{{company.id}}">Voir detail</a>
                          </div>
                        </td>








                      </tr>

                    </tbody>
                  </table>
                </div>

                <div class="alert alert-warning text-center mt-5" role="alert"
                *ngIf="!listCandidat?.length && !loadSpinnerTable">
                <img src="/assets/media/errors/no-data.png" alt="" class="mb-5">
                <span class="empty-list">
                  La liste est vide
                </span>
              </div>
              <div class="pagination" *ngIf="listCandidat && listCandidat.length">
                <app-pagination [data]="listCandidat" [lengthData]="totalItems" [currentPageList]="currentPage"  (setPages)="getItems($event)">
                </app-pagination>
              </div>
                <!--end::Table-->
              </div>
            </div>

          </div>
          <!--end::Card body-->
        </div>

        <!--end::Card-->
        <!--begin::Modals-->
        <!--begin::Modal - Customers - Add-->

        <!--end::Modal - Customers - Add-->
        <!--begin::Modal - Adjust Balance-->

        <!--end::Modal - New Card-->
        <!--end::Modals-->
        
      </div>
      <!--end::Content container-->
    </div>
    <!--end::Content-->
  </div>
  <!--end::Content wrapper-->
  <!--begin::Footer-->

  <!--end::Footer-->
  <!--end:::Main-->
</div>
<ng-template #send>
  <!--begin::Modal content-->
  <div class="modal-content" >
      <!--begin::Modal header-->
      <div class="modal-header pb-0 border-0 justify-content-end">
          <!--begin::Close-->
          <div class="btn btn-sm btn-icon btn-active-color-primary" (click)="closeModal()" >
              <i class="ki-duotone ki-cross fs-1">
                  <span class="path1"></span>
                  <span class="path2"></span>
              </i>
          </div>
          <!--end::Close-->
      </div>
      <!--begin::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body scroll-y mx-5 mx-xl-18 pt-0" [formGroup]="applyForm" >
          <!--begin::Heading-->
          <div class="text-center mb-13">
              <!--begin::Title-->
              <h1 class="mb-3">Dossier de candidature </h1>
          </div>
          <!--end::Heading-->
          
      
          <div class="mb-10">
            <label for="argument ">Argument Commercial</label>
            <textarea name="argument" id="argument" placeholder="Argument Commercial" formControlName="commercial_argument" class="form-control" readonly></textarea>
        </div>
        <div class="mb-10">
            <label for="date"  >Date de disponibilite </label>
                <input type="date" formControlName="availibility_date" class="form-control style-input" readonly>
            </div>
        <div class="mb-10">
            <label for="prix"  >Prix de la proposition</label>
            <input type="text" class="form-control style-input" formControlName="tjm_vente"  placeholder="TJM (vente)" readonly>
        </div>
          <!--begin::Users-->
      
          <!--end::Users-->
          <!--begin::Notice-->
      
          <!--end::Notice-->
      </div>
      
      <div class="modal-footer">
          <!-- <a  class="annuler" (click)="closeModal()" style="cursor: pointer;">Annuler</a>
          <a  class="confirmer"  style="cursor: pointer;" (click)="applyCandidateJob(idJobs, state, postuled,'apply')"> Postuler <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.3014 6.93489L1.8289 0.125525C1.60951 0.0223123 1.36294 -0.0185918 1.11926 0.00780132C0.875591 0.0341944 0.645346 0.126744 0.456611 0.274162C0.267876 0.42158 0.128808 0.617495 0.0563695 0.838012C-0.0160691 1.05853 -0.0187478 1.29412 0.04866 1.51604L1.89651 7.60228H8.49911C8.61083 7.60228 8.71798 7.64404 8.79698 7.71838C8.87598 7.79272 8.92036 7.89355 8.92036 7.99868C8.92036 8.10382 8.87598 8.20464 8.79698 8.27899C8.71798 8.35333 8.61083 8.39509 8.49911 8.39509H1.89651L0.04866 14.4813C-0.00455989 14.6581 -0.0136708 14.8441 0.0220375 15.0248C0.0577458 15.2055 0.137309 15.3759 0.254525 15.5229C0.371741 15.6699 0.523444 15.7894 0.69781 15.8722C0.872177 15.9549 1.0645 15.9987 1.25978 16C1.45757 15.9996 1.65252 15.9557 1.82911 15.8718L16.3014 9.06248C16.5114 8.96368 16.6879 8.81182 16.8113 8.62394C16.9347 8.43605 17 8.21955 17 7.99868C17 7.77782 16.9347 7.56132 16.8113 7.37343C16.6879 7.18554 16.5114 7.03369 16.3014 6.93489Z" fill="white"/>
              </svg>
          </a>
           -->

      </div>
      <!--end::Modal body-->
  </div>
  <!--end::Modal content-->
</ng-template>